<div class="my-2">
  <app-drug-akas [matchingPrescriberDrug]="matchingPrescriberDrug" />
  <div class="row g-0 mt-3">
    <div class="col">
      <div><strong>DRUG GROUP</strong></div>
      <div>{{ matchingPrescriberDrug.drugGroup && matchingPrescriberDrug.drugGroup.name }}</div>
    </div>
    <div class="col ms-3">
      <div><strong>VALUE</strong></div>
      <div>{{ matchingPrescriberDrug.totalEstimatedValue | currency }}</div>
    </div>
  </div>
  <div class="row g-0 mt-3">
    <div class="col">
      <div><strong>RX-DRUG(S)</strong></div>
      <div>{{ matchingPrescriberDrug.relatedDrugDescriptions | joinList }}</div>
    </div>
    <div class="col ms-3">
      <div><strong>NDC(S)</strong></div>
      <div>{{ matchingPrescriberDrug.relatedNdcs | joinList }}</div>
    </div>
  </div>
  <div class="row g-0 mt-3">
    <div class="col">
      <div><strong>PRESCRIBER(S)</strong></div>
      <div>{{ prescriberNames | joinList }}</div>
    </div>
    <div class="col ms-3">
      <div><strong>RX-WRITTEN DATE(S)</strong></div>
      @for (checkedWrittenDate of checkedWrittenDates; track checkedWrittenDate; let isLast = $last) {
        <span>
          {{ checkedWrittenDate.date | date: 'M/d/yyyy' }}
          <ng-container>
            @if (checkedWrittenDate.dateWithinRange === true) {
              <fa-icon
                [icon]="['fas', 'check']" size="1x" class="check" />
            }
            @if (checkedWrittenDate.dateWithinRange === false) {
              <fa-icon
                [icon]="['fas', 'exclamation-triangle']" size="1x" class="warning" />
            }
            @if (!isLast) {
              <span class="me-2">,</span>
            }
          </ng-container>
        </span>
      }
    </div>
  </div>
  <div class="row g-0 mt-3">
    <div class="col">
      <div><strong>CAPTURE COUNT</strong></div>
      <div>{{ matchingPrescriberDrug.relatedCaptureCount }}</div>
    </div>
  </div>
</div>
